import type { KeyboardEvent, SVGProps } from 'react';

interface SelectableMarkArgs {
  code: string;
  name: string;
  isSelected: boolean;
  onSelect?: (code: string) => void;
}

/**
 * The attributes that make a tyre mark a button when the diagram can select
 * (role, keyboard activation, pressed state) and a plain image when it only
 * shows. The plan chart is the keyboard path to every tyre, since the 3D model is picked with a pointer.
 */
export function selectableMarkProps({ code, name, isSelected, onSelect }: SelectableMarkArgs): SVGProps<SVGGElement> {
  const label = `Tyre position ${code}, ${name}`;
  if (!onSelect) return { role: 'img', 'aria-label': label };
  return {
    role: 'button',
    tabIndex: 0,
    'aria-pressed': isSelected,
    'aria-label': label,
    onClick: () => onSelect(code),
    onKeyDown: (event: KeyboardEvent<SVGGElement>) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      onSelect(code);
    },
  };
}
